import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FcpIconComponent } from './fcp-icon.component';
import * as regularIcons from './regular-icons';
import * as solidIcons from './solid-icons';
import * as brandIcons from './brand-icons';
import * as lightIcons from './light-icons';
import * as thinIcons from './thin-icons';

@NgModule({
    imports: [CommonModule, FontAwesomeModule],
    declarations: [FcpIconComponent],
    exports: [FcpIconComponent]
})
export class FcpIconModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(
            ...Object.values(regularIcons),
            ...Object.values(solidIcons),
            ...Object.values(brandIcons),
            ...Object.values(lightIcons),
            ...Object.values(thinIcons)
        );
    }
}
